import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { SalesManagerOrdersService } from "./salesmanagerorders.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { SalesManagerOrdersMainComponent } from "./salesmanagerorders.main.component";
import { saveAs } from "file-saver";
import moment from "moment";
import { SalesManagerOrder } from "src/app/api-models/SalesManagerOrder";

@Component({
    selector: "app-salesmanagerorders",
    templateUrl: "./salesmanagerorders.component.html",
    styleUrls: ["salesmanagerorders.component.scss"],
    standalone: false
})
export class SalesManagerOrdersComponent extends BaseMaterialDatatableComponent<SalesManagerOrder> implements OnInit {
    public UTCDATEFORMAT: string = "";

    constructor(
        private salesManagerOrdersService: SalesManagerOrdersService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: SalesManagerOrdersMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: salesManagerOrdersService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_sales_manager_orders_list"
            },
            sortState: {
                active: "created",
                direction: "desc"
            },
            displayedColumns: ["salesManager", "distributor", "itemCount", "created", "actions"],
            listService: salesManagerOrdersService
        });

        this.UTCDATEFORMAT = this.salesManagerOrdersService.UTCDATEFORMAT;
    }

    viewOrder(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }
}
